import Vue from 'vue'
import store from './store'
import ElementUI from 'element-ui'
import './assets/css/style.scss'
import router from './router/'
import Config from './config/app'
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
// import Blob from './utils/excel/Blob.js'
// import Export2Excel from './utils/excel/Export2Excel.js'
import {
  isLogin
}
from './utils/dataStorage'
import {
  formatDate,
  numberFormat
} from './utils/index'
import * as echarts from 'echarts'
 
Vue.prototype.$echarts = echarts

import App from './App.vue'


Vue.prototype.$Config = Config

Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title ? to.meta.title + '-' + Config.siteName : Config.siteName

  if (!isLogin() && to.path !== '/login') {
    next({
      path: '/login'
    })
  } else {
    next()
  }
})
router.afterEach(transition => {

})

Vue.filter('dateTime', function(v) {
  if (!v) return '-'
  const date = new Date(parseInt(v))
  return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
})
Vue.filter('amountRMB', function(v) {
  return '￥' + numberFormat(v, 2)
})
Vue.filter('amountUSDT', function(v) {
  return (v / 100).toFixed(2)
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
